import { Component } from "@angular/core";
import { AuthService } from "../auth.service";
// import { ToastrManager } from "ng6-toastr-notifications";
import { dataType } from "../dataType";
import { Router } from "@angular/router";

@Component({
  selector: "app-signup",
  templateUrl: "./signup.component.html",
  styleUrls: ["./signup.component.css"]
})
export class SignupComponent {
  public data = new dataType();
  public submitted = false;
  public otp = new dataType();
  public clientid= '5k7di7io0o8e46q4sj4gogki9r';

  constructor(private auth: AuthService,private router: Router) {}

  ngOnInit() {}

  signupUser() {
    this.data["clientid"]= this.clientid;
    console.log(this.data);
    this.auth.signupUser(this.data).subscribe((res: any) => {
      console.log(res);
      if (typeof res == "string") {
        res = JSON.parse(res);
      }
      if (res.Status == "Error") {
        alert(res.Error.message)
        // this.toastr.errorToastr(res.Error.message, "Oops!");
      } else {
        // this.toastr.successToastr("User SignUp Successful", "Success!");
        alert("User Signup Successfull")
        this.submitted=true;
      }
    });
  }

  confirmUser(){
    this.otp["clientid"]= this.clientid;
    this.otp["username"]= this.data.username;
    console.log(this.otp)
    this.auth.confirmUser(this.otp).subscribe((res:any)=>{
      console.log(res)
      if(typeof res == 'string'){
        res = JSON.parse(res)
      }
      if(res.Status== "Success"){
        alert("User Created Successfully")
      }else{
        alert(res.Error.message)
      }this.router.navigate(['/login'])
    });
  }
}
